/**
 * ScrambleText용 `chars`: 표시 문구와 동일한 문자 집합(멀티셋)이라
 * 중간 단계가 기호/숫자 오타가 아니라 같은 글자들의 섞임(애너그램 느낌)으로 보이게 함.
 */
export function multisetCharsForScramble(text: string): string {
    const t = text.replace(/\s+/g, " ").trim();
    if (t.length === 0) {
        return "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    }
    return t;
}
